import { render, staticRenderFns } from "./colorSelector.vue?vue&type=template&id=fc07e3a2&"
import script from "./colorSelector.vue?vue&type=script&lang=ts&"
export * from "./colorSelector.vue?vue&type=script&lang=ts&"
import style0 from "./colorSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports